import React, { useState, useEffect } from 'react';
import { MdOutlineCancel } from 'react-icons/md';
import DeleteIconButton from "../../components/IconButtons/DeleteIconButton";
import { useStateContext } from '../../contexts/ContextProvider';
import { useCentroCostosMutations } from '../../hooks';
import { getUsuariosSucursal } from '../../services/UsuarioSucursal';
import { getMandantes } from '../../services/Mandantes';
import DataTable from 'react-data-table-component';
import SearchUsuario from '../Search/SearchUsuario';
import { FooterPages } from '..';
import { Toaster, toast } from 'react-hot-toast';

const initialState = {
  empresa: '',
  codigo: '',
  nombreProyecto: '',
  ubicacion: '',
  idMandante: null,
  idJefeAdmin: null,
  idAprobador: null,
  idAdministrador: null,
  expeditores: [],
  estado: 'Activo',
};

const NuevoCentroCostoLF = ({ vecinoData, onChangeVecino }) => {
  const { currentColor, isClicked, setIsClicked } = useStateContext();
  const [formData, setFormData] = useState(initialState);
  const [usuarioData, setUsuarioData] = useState([]);
  const [usuarioJefe, setUsuarioJefe] = useState([]);
  const [usuarioJefeAdmin, setUsuarioJefeAdmin] = useState([]);
  const [dataMandante, setDataMandante] = useState([]);
  const [expeditoresData, setExpeditoresData] = useState([]);
  const { addCentroCosto, updateCentroC } = useCentroCostosMutations();

  const inputClass = "text-[11px] border border-gray-300 p-1.5 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-400";

  useEffect(() => {
    if (vecinoData) {
      setFormData(vecinoData);
      setExpeditoresData(vecinoData.expeditores);
    }
  }, [vecinoData]);

  useEffect(() => {
    const fetchData = async () => {

      const misMandantes = await getMandantes();
      setDataMandante(misMandantes);

      const misUsuario = await getUsuariosSucursal();
      const filtrados = misUsuario.filter((usuario) => usuario.rol === 'Administrador');
      setUsuarioData(filtrados);
      const filtradosJefe = misUsuario.filter((usuario) => usuario.rol === 'Jefe de oficina técnica');
      setUsuarioJefe(filtradosJefe);

      const filtradosJefeAdmin = misUsuario.filter((usuario) => usuario.rol === 'Jefe Administrativo');
      setUsuarioJefeAdmin(filtradosJefeAdmin);

    };
    fetchData();
  }, []);


  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const validarFormulario = () => {

    if (!formData.codigo || formData.codigo.trim() === "") {
      toast.error("Debe ingresar el Centro de Costo.");
      return false;
    }

    if (formData.codigo.length < 3) {
      toast.error("El código del Centro de Costo debe tener al menos 3 caracteres.");
      return false;
    }

    if (!formData.nombreProyecto || formData.nombreProyecto.trim() === "") {
      toast.error("Debe ingresar el Nombre del Proyecto.");
      return false;
    }

    if (formData.nombreProyecto.length < 3) {
      toast.error("El Nombre del Proyecto es demasiado corto.");
      return false;
    }

    if (!formData.ubicacion || formData.ubicacion.trim() === "") {
      toast.error("Debe ingresar la Ubicación.");
      return false;
    }

    if (!formData.idMandante) {
      toast.error("Debe seleccionar un Mandante.");
      return false;
    }

    if (!formData.idAdministrador) {
      toast.error("Debe seleccionar un Administrador.");
      return false;
    }

    if (!formData.idAprobador) {
      toast.error("Debe seleccionar un Jefe de Oficina Técnica.");
      return false;
    }

    if (!formData.idJefeAdmin) {
      toast.error("Debe seleccionar un Jefe Administrativo.");
      return false;
    }

    if (expeditoresData.length === 0) {
      toast.error("Debe agregar al menos un Expeditor.");
      return false;
    }

    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validarFormulario()) return;

    // Transformar expeditores a solo los ids esperados
    const expeditoresTransformados = expeditoresData.map((exp) => ({
      idExpeditor: exp.idUsuario,
    }));

    // Crear un nuevo objeto formateado para enviar
    const dataParaEnviar = {
      ...formData,
      expeditores: expeditoresTransformados,
    };

    if (!vecinoData._id) {
      // console.log('crear VECINO');
      await addCentroCosto.mutateAsync(dataParaEnviar);
    } else {
      await updateCentroC.mutateAsync(dataParaEnviar);
    };
    onChangeVecino('REFRESH');
    setIsClicked(!isClicked.nuevoccosto);

  }

  const handleEliminar = async (row) => {
    //console.log('voy a eliminar ' + row._id);
    setExpeditoresData((prevData) => prevData.filter((item) => item._id !== row._id));
    //  await removeCentroCosto.mutateAsync(row._id);
    setExpeditoresData((prevData) => (prevData));
  };

  const customStyles = {
    table: {
      style: {
        backgroundColor: 'white',
      },
    },
    headRow: {
      style: {
        backgroundColor: 'white',
        fontSize: 12,
        borderRadius: 8,
        fontWeight: '400',
        color: '#AEB2D7',
        borderWidth: 0,
        textAlign: 'center',
        headerStyles: {
          backgroundColor: '#F2F5FE',
          fontWeight: 'bold',
          color: '#2F336A',
        },
      },
    },
    rows: {
      style: {
        minHeight: '50px',
        margin: '4px 0px',
        backgroundColor: 'white',
        borderRadius: 8,
        fontSize: 10,
        rowStyles: {
          borderBottom: 1,
        }
      },
    },
  };

  const columns = [
    {
      name: '',
      width: '40px',
      cell: (row) => (<DeleteIconButton onClick={() => handleEliminar(row)} />)
    },
    {
      name: 'Nombre Expeditor',
      width: '280px',
      selector: row => row.nombre,
      sortable: true
    }

  ];

  return (
    <form onSubmit={handleSubmit} >
      <div className="bg-half-transparent w-full fixed nav-item top-0 right-0">
        <div className="overflow-y-scroll float-right h-screen duration-1000 ease-in-out dark:text-gray-200 transition-all dark:bg-[#484B52] bg-gray-100  w-full md:w-1/2 p-8">

          <div className="flex justify-between items-center px-4 py-2 border-b border-gray-200 bg-white rounded-t-md shadow-sm">
            <div className="flex items-center gap-2">
              <div className="w-2.5 h-2.5 rounded-full bg-blue-500 animate-pulse" />
              <p className="text-gray-800 font-semibold text-base md:text-lg">
                {!vecinoData ? "Nuevo" : "Editar"} Proyecto
              </p>
            </div>

            <button
              type="button"
              onClick={() => setIsClicked(!isClicked.nuevoccosto)}
              className="text-gray-400 hover:text-red-500 transition-colors duration-150 p-2 rounded-full hover:bg-gray-100"
              aria-label="Cerrar"
            >
              <MdOutlineCancel className="text-xl md:text-2xl" />
            </button>
          </div>

          <div className="mt-5 space-y-4">

            <div className="md:col-span-2 bg-white p-6 rounded-lg shadow-lg">
              <div className="grid grid-cols-1 md:grid-cols-4 gap-4" >
                <div className="flex flex-col ">
                  <label className="text-xs font-semibold mb-1">Centro Costo</label>
                  <input
                    type="text"
                    className={inputClass}
                    placeholder=""
                    name="codigo"
                    value={formData.codigo}
                    required
                    onChange={handleChange}
                  />
                </div>
                <div className="col-span-3">
                  <div className="flex flex-col ">
                    <label className="text-xs font-semibold mb-1">Nombre Proyecto</label>
                    <input
                      type="text"
                      className={inputClass}
                      placeholder=""
                      name="nombreProyecto"
                      value={formData.nombreProyecto}
                      required
                      onChange={handleChange}
                    />
                  </div>
                </div>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mt-5" >
                <div className="col-span-2">
                  <div className="flex flex-col ">
                    <label className="text-xs font-semibold mb-1">Mandante</label>
                    <select className={inputClass} name="idMandante"
                      value={formData.idMandante} onChange={handleChange}>
                      <option value=""></option>
                      {dataMandante?.map((item, index) => (
                        <option key={item._id} value={item._id}>{item.razonSocial}</option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="col-span-2">
                  <div className="flex flex-col ">
                    <label className="text-xs font-semibold mb-1">Ubicación</label>
                    <input
                      type="text"
                      className={inputClass}
                      placeholder=""
                      name="ubicacion"
                      value={formData.ubicacion}
                      required
                      onChange={handleChange}
                    />
                  </div>
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-5 gap-6 mt-5" >
                <div className="col-span-2">
                  <div className="flex flex-col ">
                    <label className="text-xs font-semibold mb-1">Jefe Administrativo</label>
                    <select className={inputClass} name="idJefeAdmin"
                      value={formData.idJefeAdmin} onChange={handleChange}>
                      <option value=""></option>
                      {usuarioJefeAdmin?.map((item, index) => (
                        <option key={item._id} value={item._id}>{item.nombre}</option>
                      ))}
                    </select>

                  </div>
                </div>
                <div className="col-span-2">
                  <div className="flex flex-col ">
                    <label className="text-xs font-semibold mb-1">Jefe Of. Técnica</label>
                    <select className={inputClass} name="idAprobador"
                      value={formData.idAprobador} onChange={handleChange}>
                      <option value=""></option>
                      {usuarioJefe?.map((item, index) => (
                        <option key={item._id} value={item._id}>{item.nombre}</option>
                      ))}
                    </select>

                  </div>
                </div>
                <div className="col-span-2">
                  <div className="flex flex-col ">
                    <label className="text-xs font-semibold mb-1">Administrador</label>
                    <select className={inputClass} name="idAdministrador"
                      value={formData.idAdministrador} onChange={handleChange}>
                      <option value=""></option>
                      {usuarioData?.map((item, index) => (
                        <option key={item._id} value={item._id}>{item.nombre}</option>
                      ))}
                    </select>

                  </div>
                </div>
                <div className="flex flex-col">
                  <label className="text-xs font-semibold mb-1">Estado</label>
                  <select className={inputClass} name="estado" value={formData.estado} required onChange={handleChange}>
                    <option value="Activo">Activo</option>
                    <option value="Inactivo">Inactivo</option>
                    <option value="Eliminado">Eliminado</option>
                  </select>

                </div>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-5 gap-6 mt-5" >
                {/* AQUI VA LA TABLA CON EXPEDITORES */}
                <div className="flex flex-col ">
                  <SearchUsuario
                    rol='Expeditor'
                    asignacion='Disponible'
                    onValorSeleccionadoChange={(docSeleccionado) => {
                      if (!docSeleccionado) return;

                      setExpeditoresData((prev) => {
                        // Evitar duplicados por idUsuario
                        const yaExiste = prev.some((exp) => exp.idUsuario === docSeleccionado.idUsuario);
                        if (yaExiste) return prev;
                        return [...prev, docSeleccionado];
                      });

                    }}
                  />
                </div>
                <div className="col-span-5">
                  <div className="flex flex-col ">
                    <DataTable
                      columns={columns}
                      data={expeditoresData}
                      highlightOnHover
                      pagination={true}
                      striped
                      className="border border-gray-300 rounded-lg shadow-sm"
                      noHeader={true}
                      selectableRowsHighlight
                      customStyles={customStyles}
                      noDataComponent={'No hay expeditores asignados'}
                    />
                  </div>
                </div>
              </div>

            </div>
            <div className="bg-white p-6 rounded-lg shadow-lg items-end">
              <button
                onClick={handleSubmit}
                className="bg-blue-600 text-white py-2 px-4 rounded mt-4"
              >
                {!vecinoData ? "Crear Nuevo" : "Guardar Cambios"}
              </button>
            </div>
            <Toaster
              position="top-right"
              toastOptions={{
                style: {
                  zIndex: 9999,
                },
              }}
            />

            <FooterPages />
          </div>

        </div>
      </div>
    </form>
  );
};

export default NuevoCentroCostoLF;